import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  OnInit,
  Output,
  signal,
  viewChild,
} from "@angular/core";
import { BaseConfig } from "../../../common/config/config.adapter";

@Component({
  selector: "app-time-picker",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.scss"],
})
export class InputTimePicker
  extends BaseConfig
  implements OnInit, AfterViewInit
{
  minutesRef = viewChild<ElementRef<HTMLElement>>("minutesRef");
  hoursRef = viewChild<ElementRef<HTMLElement>>("hoursRef");

  currentTime = input<string>();
  _currentTime = computed(() => {
    const value = this.currentTime();
    const isPM = Number(value?.split(":")[0]) >= 12;
    this.isPM.set(isPM);

    this.time.set(value!);
  });

  @Output() pick = new EventEmitter<string>();

  time = signal<string>("00:00");

  hours = computed<string[]>(() => {
    const hours = [];
    for (let i = 1; i < 13; i++) {
      if (this.isPM() && i === 12) {
        break;
      }
      hours.push(i.toString().padStart(2, "0"));
    }

    return hours;
  });
  minutes = signal<string[]>(["00"]);

  currentHour = computed(() => {
    const hour = this.time().split(":")[0];
    if (!this.isPM()) {
      return hour === "00" ? "12" : hour;
    }

    return hour;
  });
  currentMinute = computed(() => this.time().split(":")[1]);

  isPM = signal<boolean>(false);

  isSameHour(hour: string) {
    if (Number(this.currentHour()) > 12) {
      return (
        hour === (Number(this.currentHour()) - 12).toString().padStart(2, "0")
      );
    }

    return hour === this.currentHour();
  }

  ngOnInit(): void {
    for (let i = 1; i < 60; i++) {
      this.minutes().push(`${i.toString().padStart(2, "0")}`);
    }
  }

  ngAfterViewInit(): void {
    this.handleScroll();
  }

  handleScroll() {
    const currentHour = document.querySelector(`#hour-${this.currentHour()}`);
    if (currentHour) {
      this.hoursRef()?.nativeElement.scrollTo({
        behavior: "smooth",
        top: currentHour["clientTop"] - 32,
      });
    }

    const currentMinute = document.querySelector(
      `#minute-${this.currentMinute()}`,
    );
    if (currentMinute) {
      this.minutesRef()?.nativeElement.scrollTo({
        behavior: "smooth",
        top: currentMinute["clientTop"] - 32,
      });
    }
  }

  selectHour(hour: string) {
    this.time.set(`${hour}:${this.currentMinute()}`);
    this.change();
  }

  selectMinute(minute: string) {
    this.time.set(`${this.currentHour()}:${minute}`);
    this.change();
  }

  toggleAMPM(boolean: boolean) {
    this.isPM.set(boolean);
    this.change();
  }

  validate() {
    const [hour, minute] = this.time().split(":");
    if (this.isPM()) {
      if (Number(hour) < 12) {
        this.time.set(
          `${(Number(hour) + 12).toString().padStart(2, "0")}:${minute}`,
        );
      }
    } else {
      if (Number(hour) >= 12) {
        this.time.set(
          `${(Number(hour) - 12).toString().padStart(2, "0")}:${minute}`,
        );
      }
    }
  }

  change() {
    this.validate();
    this.pick.emit(this.time());
  }
}
